<template>
    <section class="landscape-products-wrap " v-if="hasAnyProduct">
        <div class="products-header">
            <h5 class="section-title mbold">Produits fréquemment achetés ensemble</h5>
        </div>

        <div class="landscape-products row zonefreq" ref="productsPlaceholder">
            <div class="col-9 col-sm-4 pere-freq-sansplus">
                <input class="checkfreq" type="checkbox" v-model="principalChecked" @change="updateTotal">
                <ProductCard :key="0" :product="principal"></ProductCard>
            </div>

            <div class="col-9 col-sm-4 pere-freq-plus" v-for="(product, index) in products" :key="index + 1">
                <input class="checkfreq" type="checkbox" v-model="product.checked" @change="updateTotal"
                    :checked="product.checked">
                <font class="freq-plus">+</font>
                <ProductCard :key="index + 1" :product="product"></ProductCard>

            </div>
 
            <div class="col-18 col-sm-6 bouttons-freq-plus"  >
                <div class="zone1">
                    <strong>Prix total:</strong>
                    <strong v-html="total" class="price "></strong>
                </div>
                <div class="details-info-middle-actions">
                    <button type="submit" class="btn btn-primary btn-add-to-cart" @click="addToCartForCheckedProducts()">
                        <i class="las la-cart-arrow-down"></i>
                        Ajouter ces <font v-html="totaltxt" ></font> articles au Panier
                    </button>
                </div>
            </div>

        </div>
    </section>
</template>
  
<script>
import store from '../../../store';

import ProductCard from './../../ProductCard.vue';

export default {
    components: { ProductCard },

    props: ['products', 'principal'],
    data() {
        return {
            principalChecked: true,
            total: 0,
            totaltxt: '',
        };
    },
    methods: {
        addToCart(product) {
            // Assuming you have the "$" and "store" objects available for handling the cart
            $.ajax({
                method: 'POST',
                url: route('cart.items.store', { product_id: product.id, qty: 1 }),
            })
                .then((cart) => {
                    store.updateCart(cart);
                    $('.header-cart').trigger('click');
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
        },

        addToCartForCheckedProducts() {
            var productsToAdd = this.products.filter((product) => product.checked);

           
            productsToAdd.forEach((product) => {
                this.addToCart(product);
            });
             if (this.principalChecked && this.principal) {
                productsToAdd.push(this.principal);
            }

        },

        updateTotal() {
            this.total = this.products.reduce(
                (accumulator, product) =>
                    accumulator + (product.checked ? parseFloat(product.selling_price.amount) : 0),
                this.principalChecked ? parseFloat(this.principal.selling_price.amount) : 0
            );
            this.total = this.total.toFixed(3)+' TND';
            
            this.totaltxt=(this.products.length==2)? 'trois' :  'deux';
         },

        checkAllProducts() {

            this.products.forEach((product) => (product.checked = true));
            this.principalChecked = true;
            this.updateTotal();
        },


    },

    computed: {
        hasAnyProduct() {
            return this.products.length !== 0;
        },
    },

    mounted() {
        this.checkAllProducts();
    }

};
</script>